
interface branchItem {
  content: string;
  desc: string;
}

interface Props {
  title: string;
  list: branchItem[];
}

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['input-click'],
  setup(props: Props, { emit }) {
    const listItemClick = (branch: branchItem): void => {
      emit('input-click', branch);
    };
    return {
      props,
      listItemClick,
    };
  },
};
